'use client';

import { motion } from 'framer-motion';
import { ReactNode } from 'react';

export type AnimatedHeightProps = {
  children: ReactNode;
  isExpanded: boolean;
  className?: string;
  duration?: number;
};

const AnimatedHeight: React.FC<AnimatedHeightProps> = ({
  children,
  isExpanded,
  className = '',
  duration = 0.4,
}) => {
  return (
    <motion.div
      className={`overflow-hidden ${className}`}
      initial={false}
      animate={{ height: isExpanded ? 'auto' : 0 }}
      transition={{
        duration,
        ease: 'easeInOut',
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedHeight;
